export interface ArticleItem {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  tags: string[];
}

export const articles: ArticleItem[] = [
  {
    id: 'article-1',
    title: '大一新生必看：大学四年发型进化指南',
    summary: '从高中到大学，发型是展现个性的第一步。这篇文章告诉你如何根据脸型、发质以及不同年级的氛围，选择最适合你的发型。',
    content: `<p>进入大学，意味着全新的开始。告别了中学时代的统一发型要求，大学给了你充分的自由去探索和表达自己。而发型，往往是你给人留下第一印象的关键。</p>
    <h3>大一：找到适合自己的基础发型</h3>
    <p>刚入学的你，可能还不太确定什么样的发型最适合自己。建议从几个经典的基础发型入手：中长发是最安全的选择，可以扎可以放，变化多端。圆脸的女生可以尝试层次感较强的锁骨发，能够很好地修饰脸型。方脸的同学则适合带有弧度的长刘海，柔化脸部线条。</p>
    <p>大一的课程通常比较满，所以一个<strong>好打理的发型</strong>非常重要。不需要花太多时间在造型上，但要保持清爽干净的状态。</p>
    <h3>大二：尝试染烫，展现个性</h3>
    <p>大二是一个转折点，你开始适应大学生活，也有了更多属于自己的时间。这个阶段可以大胆尝试一些变化——柔和的发色、自然的卷度都是不错的选择。</p>
    <p>推荐尝试<strong>蜂蜜茶色、焦糖棕色</strong>这些温暖又显白的颜色，不会太张扬，但又能看出你的用心。卷度方面，慵懒的<strong>韩式波浪烫</strong>非常适合日常出街和上课，自然不做作。</p>
    <h3>大三：精致造型，为实习做准备</h3>
    <p>大三开始面临实习和求职，发型需要兼顾<strong>专业感与时尚感</strong>。建议回归精致简约的路线，比如柔顺的直发或微卷的及肩发。发色可以选择接近自然的深色系，如黑茶色、深巧克力色。</p>
    <p>这个阶段护发比造型更重要，定期做深层护理，让头发保持健康光泽的状态，面试时也会更加自信。</p>
    <h3>大四：百变随心，做最自信的自己</h3>
    <p>大四的你已经足够了解自己，知道什么最适合自己。毕业照、散伙饭、毕业旅行……这是属于你的高光时刻。大胆尝试之前想做但不敢做的造型吧——<strong>渐变染、个性短发、气质长卷发</strong>，用最美的姿态迎接人生的新篇章。</p>`,
    category: '美发造型',
    author: '小莎学姐',
    date: '2026-08-05',
    readTime: '6分钟',
    imageSeq: 'article-1',
    tags: ['发型推荐', '新生指南', '校园生活'],
  },
  {
    id: 'article-2',
    title: '学生党平价护肤攻略：每月不到100元也能拥有好皮肤',
    summary: '有限的预算也能做好护肤？当然可以！本文分享适合大学生的高性价比护肤方案，教你用最少的钱养出最好的皮肤状态。',
    content: `<p>很多学妹问我：学姐，每个月生活费有限，怎么护肤才不会吃土？其实护肤不一定要花大价钱，<strong>科学的方法+适合的产品</strong>才是关键。今天就来分享我总结的学生党护肤攻略。</p>
    <h3>第一步：认清自己的肤质</h3>
    <p>这是最重要的一步，也是最容易被忽略的。很多人跟风买爆款产品，结果越用越差。先搞清楚你是<strong>油性、干性、混合性还是敏感性</strong>肌肤。简单的判断方法：洗脸后不擦任何东西，等30分钟——</p>
    <ul>
    <li>T区和脸颊都出油 → 油性肌</li>
    <li>全脸紧绷干燥 → 干性肌</li>
    <li>T区油、脸颊干 → 混合肌</li>
    <li>容易泛红刺痛 → 敏感肌</li>
    </ul>
    <h3>第二步：精简护肤流程</h3>
    <p>学生党不需要十步护肤法，<strong>清洁+保湿+防晒</strong>三步走就够了。这三样做好了，皮肤状态就能超越80%的人。</p>
    <p>清洁：选择氨基酸洁面，温和不刺激。早晚各一次，不要过度清洁破坏皮肤屏障。</p>
    <p>保湿：乳液或面霜根据肤质选择，油皮选清爽型乳液，干皮选滋润型面霜。不需要花里胡哨的功能，保湿做好了皮肤自然会变好。</p>
    <p>防晒：这是最重要的抗老投资！一年四季都要涂，室内也要涂。紫外线是皮肤老化的第一大元凶。</p>
    <h3>第三步：定期专业护理</h3>
    <p>每个月可以来沙龙做一次<strong>基础清洁补水</strong>，专业的手法加上专业的仪器，效果远比自己在家折腾好得多。一次护理才68元，比买一堆没用的护肤品划算多了。</p>`,
    category: '护肤管理',
    author: '小莎学姐',
    date: '2026-08-03',
    readTime: '5分钟',
    imageSeq: 'article-2',
    tags: ['护肤攻略', '学生党', '平价好物'],
  },
  {
    id: 'article-3',
    title: '2026年秋季校园最流行的3款发型趋势',
    summary: '又到开学季，今年秋天什么发型最火？我们总结了2026年秋季最受校园女生欢迎的3款发型，让你走在时尚前沿。',
    content: `<p>新学期新气象，换个新发型去上学，心情都会变好！我们整理了2026年秋季<strong>校园最流行的3款发型</strong>，每一款都经过了实际验证，好看又好打理。</p>
    <h3>第一名：慵懒锁骨发</h3>
    <p>长度在锁骨位置的层次发型，兼具长发的温柔和短发的灵动。最大的优点是<strong>不挑脸型</strong>，圆脸、方脸、长脸都能驾驭。</p>
    <p>造型Tips：吹头发时用手指代替梳子，从下往上抓吹，就能轻松打造出慵懒随性的蓬松感。搭配一个精致的发夹，瞬间提升精致度。</p>
    <h3>第二名：微卷云朵烫</h3>
    <p>相比传统的大波浪，云朵烫的卷度更加自然柔和，像云朵一样轻盈。特别适合<strong>发量少、发质软</strong>的女生，烫完之后发量视觉上增加一倍！</p>
    <p>这款发型的精髓在于"似卷非卷"，卷度若有若无，给人一种天生好发质的错觉。日常打理只需涂抹少量弹力素，用手抓出造型即可。</p>
    <h3>第三名：氛围感编发</h3>
    <p>不是一款固定的发型，而是一种搭配思路。在基础发型的基础上，<strong>加入简单的编发元素</strong>——侧编发、半扎编发、丝巾编发等，瞬间提升整体造型的精致感。</p>
    <p>最适合约会、拍照、参加活动时使用。而且成本很低，学会几种基础编发技巧，就能变换出十几种不同的造型。</p>`,
    category: '美发造型',
    author: '小莎学姐',
    date: '2026-07-30',
    readTime: '4分钟',
    imageSeq: 'article-3',
    tags: ['发型趋势', '秋季', '时尚穿搭'],
  },
  {
    id: 'article-4',
    title: '五分钟搞定通勤妆：专为早起困难户设计',
    summary: '早上实在起不来？没关系！这篇超快速通勤妆教程让你五分钟就能精神出门，从此告别素颜上课的尴尬。',
    content: `<p>我知道，对很多同学来说，早八课本身就够痛苦了，还要化妆？但相信我，一个<strong>简单的底妆+眉毛+口红</strong>真的只需要五分钟，而效果会让你一整天都更自信。</p>
    <h3>Step 1：防晒+隔离（1分钟）</h3>
    <p>挤出硬币大小的防晒霜，从面部中心向外均匀涂抹。选择带润色效果的防晒隔离二合一产品，可以省去额外涂粉底的时间。轻拍吸收即可。</p>
    <h3>Step 2：遮瑕+定妆（1.5分钟）</h3>
    <p>用手指或小刷子取少量遮瑕膏，点涂在<strong>黑眼圈、鼻翼泛红、痘印</strong>处，用指腹轻轻拍开。然后用散粉快速扫在全脸定妆，T区可以多扫一层。</p>
    <h3>Step 3：眉毛（1.5分钟）</h3>
    <p>眉毛是最能提升精神气的部分！用眉粉顺着眉毛生长方向填充，<strong>眉头淡、眉尾深</strong>。不用追求完美对称，自然就好。画好后用眉刷梳理一下更加自然。</p>
    <h3>Step 4：唇妆（1分钟）</h3>
    <p>选择一支<strong>日常百搭</strong>的唇釉或口红——豆沙色、西柚色、蜜桃色都很适合上课。薄涂一层用手指晕开，自然的MLBB（My Lips But Better）效果就出来了。</p>
    <p>搞定！照照镜子，是不是精神多了？记住，化妆是为了让自己开心，不是为了取悦别人。每一天都要美美地出门哦！</p>`,
    category: '美妆体验',
    author: '小莎学姐',
    date: '2026-07-25',
    readTime: '4分钟',
    imageSeq: 'article-4',
    tags: ['化妆教程', '通勤妆', '学生党'],
  },
  {
    id: 'article-5',
    title: '美甲新手入门：从选款到护理的完整指南',
    summary: '第一次做美甲不知道选什么款式？做完之后怎么护理才能更持久？这篇入门指南为你一次性解答所有疑问。',
    content: `<p>美甲是很多女生接触的第一项"变美小项目"，但第一次走进美甲店可能会有点迷茫。别担心，这篇<strong>美甲新手入门指南</strong>帮你扫清所有盲区。</p>
    <h3>怎么选款式？</h3>
    <p>如果是第一次做美甲，建议从<strong>纯色或简约款</strong>开始。纯色经典百搭，不容易看腻；简约款（比如法式、小波点）也很日常，不会太夸张。等熟悉了之后再尝试渐变、彩绘等复杂款式。</p>
    <p>颜色选择上，<strong>裸色系、豆沙色系、奶茶色系</strong>是最不容易出错的选择，手白手黑都能驾驭。如果肤色偏黄，避开荧光色；肤色偏白，基本所有颜色都友好。</p>
    <h3>甲型怎么选？</h3>
    <p>方形：适合手指细长的女生，干练利落</p>
    <p>圆形：适合指甲较短或甲床偏宽的女生，可爱温柔</p>
    <p>杏仁形：适合手指中等长度的女生，优雅显手长</p>
    <p>芭蕾形（方圆形）：最百搭的甲型，适合大多数人</p>
    <h3>做完怎么护理？</h3>
    <p>1. 做完后2小时内不要碰水</p>
    <p>2. 每天涂抹指缘油，保持指甲周围滋润</p>
    <p>3. 不要用指甲抠硬物，比如开易拉罐、抠标签</p>
    <p>4. 做家务时戴手套，避免化学清洁剂损伤甲面</p>
    <p>按照以上方法护理，美甲可以保持3-4周不掉落。</p>`,
    category: '美甲艺术',
    author: '小莎学姐',
    date: '2026-07-20',
    readTime: '5分钟',
    imageSeq: 'article-5',
    tags: ['美甲入门', '新手攻略', '护理知识'],
  },
  {
    id: 'article-6',
    title: '毕业照妆容攻略：让最美的自己定格在校园',
    summary: '毕业照是一生中最重要的照片之一。如何打造最适合拍照的完美妆容？从底妆到唇色，手把手教你。',
    content: `<p>四年时光转瞬即逝，毕业照将是你大学生活最正式的定格。在镜头前如何展现最美的自己？<strong>毕业照妆容的核心关键词是：持久、上镜、自然</strong>。</p>
    <h3>底妆：持久是第一要务</h3>
    <p>毕业照拍摄通常要持续一上午甚至一天，底妆必须<strong>超级持久</strong>。建议选择哑光妆效的粉底液，搭配控油妆前乳。T区一定要做好定妆，可以用"烘焙定妆法"——在T区厚敷一层散粉，等5分钟后扫掉，控油效果翻倍。</p>
    <h3>眼妆：深邃但不过浓</h3>
    <p>相机吃妆很严重，所以眼妆要比日常稍微浓一些，但也不能太浓。选择<strong>大地色系或玫瑰色系</strong>的眼影，用深色在眼尾三角区加深，打造自然深邃感。眼线用棕色比黑色更温柔，拉出一条自然的小尾巴。</p>
    <h3>修容：上镜显脸小的秘密</h3>
    <p>相机镜头会让脸看起来比实际大一圈，所以修容一定要做。在<strong>下颌线、颧骨下方、鼻梁两侧</strong>轻扫修容粉，额头和鼻梁打高光。但要注意过渡自然，不能有明显的色块感。</p>
    <h3>唇妆：选对颜色很重要</h3>
    <p>毕业照建议选择<strong>饱和度适中</strong>的唇色——豆沙红、干枯玫瑰、水红色都很上镜。太淡的颜色被相机吃掉后像没涂，太深的颜色则容易显老。</p>
    <p>如果觉得DIY太麻烦，可以来沙龙预约<strong>毕业照专属妆</strong>服务，128元就能获得专业化妆师一对一打造的完美毕业妆！</p>`,
    category: '美妆体验',
    author: '小莎学姐',
    date: '2026-07-15',
    readTime: '5分钟',
    imageSeq: 'article-6',
    tags: ['毕业照', '妆容攻略', '校园回忆'],
  },
];